import * as React from "react";

function SvgRightArrow(props) {
  return <svg width={9} height={16} viewBox="0 0 9 16" fill="none" {...props}><path d="M0.329505 14.049C-0.109835 14.4953 -0.109835 15.219 0.329505 15.6653C0.768845 16.1116 1.48116 16.1116 1.9205 15.6653L8.67049 8.80813C9.09639 8.37546 9.1113 7.67879 8.7043 7.22775L2.5168 0.370607C2.09696 -0.0946712 1.38532 -0.126104 0.92731 0.300402C0.469301 0.726907 0.43836 1.44984 0.858201 1.91512L6.31784 7.96563L0.329505 14.049Z" fill="currentColor" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/right-arrow_35bd6e.svg";
export { SvgRightArrow as ReactComponent };